var render = function render(){var _vm=this,_c=_vm._self._c;return (this.hours != '0' && this.minutes != '0')?_c('div',{staticClass:"tag-btn-time d-flex align-center justify-center mr-2",staticStyle:{"width":"125px"}},[_c('img',{attrs:{"src":_vm.$store.state.icons.icons['Timer'],"alt":""}}),_vm._v(" "+_vm._s(_vm.hours)+"h "+_vm._s(_vm.minutes)+"m Left ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }